export default "__VITE_ASSET__DDYSsenj__"